export default "__VITE_ASSET__Bf52H1lj__"